<template>
  <div class="pagebody">
    <div class="mine-topbox" :style="'background-image:url('+icon.wodetoppic+');'">
      <!--头部头像-->
      <div class="cu-list menu-avatar min-toptxbox" :style="{paddingTop: minesmsg.company_name!== undefined &&minesmsg.company_name!== null && minesmsg.company_name.length<18? '3.2rem':'2.2rem'}">
        <!-- :style="{display:imgList ? 'none' : 'block'}" -->
        <div class="cu-item">
          <div class="cu-avatar round lg touxiang">
            <img :src="minesmsg.avatar_url" v-if="minesmsg.avatar_url" />
            <img :src="morentx" v-else />
          </div>
          <div class="content">
            <div class="text-grey">
              <p class="text-grey-name" v-if="minesmsg.name">{{minesmsg.name}}</p>
              <p class="text-grey-name" v-else>用户{{Math.round(Math.random()*30000)}}</p>
            </div>
            <div class="text-grey">
              <p v-if="detailmsg.job_title" class="text-grey-work">{{minesmsg.job_title}}</p>
              <div v-else class="text-grey-work" @click="handleUpdateCart" :data-userid="detailmsg.id">
                职称待完善
                <span class="text-right"></span>
              </div>
            </div>
            <div class="flex text-grey-company">
              <p v-if="minesmsg.company_name" class="text-cut">{{minesmsg.company_name}}</p>
              <div v-else class="text-cut" @click="handleUpdateCart" :data-userid="detailmsg.id">
                公司信息待完善
                <span class="text-right"></span>
              </div>
            </div>
          </div>
          <div class="cardcode" @click="gotocartcode" :data-userid="detailmsg.id">
            <img class="cardcode-img" :src="icon.mineiconmpm" />
            <p class="text-grey-work">名片码</p>
          </div>
          <div class="clear"></div>
        </div>
      </div>

      <div class="topinfobox">
        <div class="topinfoitem" @click="gotoothercart" :data-userid="detailmsg.id">
          <p class="p-num">{{minesmsg.messages}}</p>
          <p>动态</p>
        </div>
        <div class="topinfoitem" @click="gotofollowbox">
          <p class="p-num">{{minesmsg.followers}}</p>
          <p>关注</p>
        </div>
        <div class="topinfoitem" @click="gotofensbox">
          <p class="p-num">{{minesmsg.fans}}</p>
          <p>粉丝</p>
        </div>
      </div>
      <!--头部图标-->
      <!--       <div class="topiconbox">
        <div class="toppicicon" @click="handleUpdateCart" :data-userid="detailmsg.id">
          <div>
            <img :src="icon.iconedit" />
          </div>
          <p>个人名片</p>
        </div>

        <div class="toppicicon" @click="gotocartcode" :data-userid="detailmsg.id">
          <div>
            <img :src="icon.iconcode" />
          </div>
          <p>名片码</p>
        </div>

        <div class="toppicicon" @click="gotomycart" :data-userid="detailmsg.id">
          <div>
            <img :src="icon.iconpic" />
          </div>
          <p>名片图</p>
        </div>

        <div class="toppicicon" @click="gotodaily">
          <div>
            <img :src="icon.iconposter" />
          </div>
          <p>每日海报</p>
        </div>
      </div> -->
    </div>
    <div class="mine-list">
      <div class="mine-list-child" @click="gotocartbox">
        <p class="cuIcon-right mine-iconright">
          <img :src="icon.jticon" />
        </p>
        <div class="mine-iconleft">
          <img :src="icon.mineiconpackage" />
          <p>名片夹</p>
        </div>
      </div>

      <div class="mine-list-child" @click="gotodaily">
        <p class="cuIcon-right mine-iconright">
          <img :src="icon.jticon" />
        </p>
        <div class="mine-iconleft">
          <img :src="icon.mineiconposter" />
          <p>每日海报</p>
        </div>
      </div>

      <div class="mine-list-child" @click="gotoexchangecart">
        <p class="cuIcon-right mine-iconright">
          <img :src="icon.jticon" />
        </p>
        <div class="mine-iconleft">
          <img :src="icon.mineiconexchange" />
          <p>交换申请</p>
          <span v-if="minesmsg.friends_request_num != 0" class="(minesmsg.friends_request_num != 0?'mine-iconleft-badge':'')">{{minesmsg.friends_request_num}}</span>
        </div>
      </div>
    </div>

    <div class="mine-list">
      <div class="mine-list-child" @click="gotocarttemplate">
        <p class="cuIcon-right mine-iconright">
          <img :src="icon.jticon" />
        </p>
        <div class="mine-iconleft">
          <img :src="icon.icontemplate" />
          <p>名片模板</p>
        </div>
      </div>

      <div class="mine-list-child" @click="gotocollection">
        <p class="cuIcon-right mine-iconright">
          <img :src="icon.jticon" />
        </p>
        <div class="mine-iconleft">
          <img :src="icon.iconcollection" />
          <p>我的收藏</p>
        </div>
      </div>

      <div class="mine-list-child" @click="gotofeedback">
        <p class="cuIcon-right mine-iconright">
          <img :src="icon.jticon" />
        </p>
        <div class="mine-iconleft">
          <img :src="icon.iconopinion" />
          <p>意见反馈</p>
        </div>
      </div>
    </div>
    <div class="loginout" @click="usersLogout">安全退出</div>
    <div class="copyright">- 鲜枇杷名片出品 -</div>
  </div>
</template>

<script>
import { getmines, getindexcartMsg, usersLogout } from "../../api/api";
import Vue from "vue";
import { Toast, Notify } from 'vant';
Vue.use(Notify);
export default {
  data () {
    return {
      icon: {
        wodetx: require("../../assets/images/cart-tx.png"),
        iconedit: require("../../assets/images/mine_icon_edit.png"),
        iconcode: require("../../assets/images/mine_icon_code.png"),
        iconpic: require("../../assets/images/mine_icon_pic.png"),
        iconposter: require("../../assets/images/mine_icon_poster.png"),
        icontemplate: require("../../assets/images/mine_icon_template.png"),
        iconcollection: require("../../assets/images/mine_icon_collection.png"),
        iconopinion: require("../../assets/images/mine_icon_opinion.png"),
        mineiconpackage: require("../../assets/images/mine_icon_package.png"),
        mineiconposter: require("../../assets/images/mine_icon_poster.png"),
        mineiconexchange: require("../../assets/images/mine_icon_exchange.png"),
        jticon: require("../../assets/images/home_icon_enter.png"),
        mineiconmpm: require("../../assets/images/mine_icon_mpm.png"),
        wodetoppic: require("../../assets/images/wode_toppic.png"),
      },
      morentx: require("../../assets/images/moren.jpg"),
      detailmsg: {},
      minesmsg: {}
    };
  },
  created () {
    document.title = '我的';
    let that = this;
    let minesmsg = that.$store.getters.getMinesmsg;
    if (minesmsg.name != null && minesmsg != "") {
      that.minesmsg = minesmsg;
    } else {
      this.getmines()
    }
  },
  methods: {
    getmines () {
      let that = this;
      getmines()
        .then(res => {
          if (res.data.code == 200) {
            this.$store.dispatch("changeMinesmsgFun", res.data.data);
            this.minesmsg = res.data.data
            console.log(this.minesmsg)
            that.initCartMsg();
          }
        })
        .catch(err => {
        });
    },
    //初始化名片信息,获取id
    initCartMsg () {
      let that = this;
      let detailmsg = that.$store.getters.getDetailmsg;
      if (detailmsg.name != null && detailmsg != "") {
        that.detailmsg = detailmsg;
      } else {
        getindexcartMsg()
          .then(res => {
            if (res.data.code == 200) {
              this.$store.dispatch("changeDetailmsgFun", res.data.data);
              that.detailmsg = res.data.data;
            }
          }).catch(err => {
          });
      }
    },
    handleUpdateCart (e) {
      this.$router.push({
        name: "cartform",
        query: {
          userid: e.currentTarget.dataset.userid
        }
      });
    },

    gotocarttemplate () {
      this.$router.push("/cartemplate");
    },
    gotofeedback () {
      this.$router.push({
        name: "feedback"
      });
    },
    gotocartcode (e) {
      this.$router.push({
        name: "cartcode",
        query: {
          id: e.currentTarget.dataset.userid,
          isown: true
        }
      });
    },
    gotoothercart: function () {
      this.$router.push({
        name: "dynamic"
      });
    },
    gotoexchangecart: function () {
      this.$router.push({
        name: "exchangecart"
      });
    },
    gotofollowbox: function () {
      this.$router.push({
        name: "followbox"
      });
    },
    gotofensbox: function () {
      this.$router.push({
        name: "fansbox"
      });
    },
    gotocartbox () {
      this.$router.push({
        name: "cartbox"
      });
    },
    gotodaily () {
      this.$router.push({
        name: "daily"
      });
    },
    gotomycart (e) {
      this.$router.push({
        name: "mycart",
        query: {
          userid: e.currentTarget.dataset.userid
        }
      });
    },
    gotocollection () {
      this.$router.push({
        name: "collection"
      });
    },
    //用户登出
    usersLogout () {
      let that = this;
      usersLogout()
        .then(res => {
          if (res.code == 200) {
            localStorage.removeItem("AUTH_TOKEN");
            localStorage.removeItem("token");
            that.$router.push({
              name: "cover"
            });
            setTimeout(() => {
              location.reload() // 强制刷新
            }, 1000)
          }
        })
        .catch(err => {
        });
    }
  }
};
</script>

<style scoped>
.clear {
  clear: both;
}
.pagebody {
  background: #f8f8f8;
  position: relative;
  height: 100%;
  overflow-y: scroll;
}
.mine-topbox {
  /* height: 11rem; */
  width: 100%;
  background-size: 100%;
  background-repeat: no-repeat;
}
.mine-topbox .min-toptxbox {
}
.mine-topbox .min-toptxbox .cu-item {
  background: none;
  color: #fff;
}
.mine-topbox .min-toptxbox .cu-item .cu-avatar.lg {
  margin-left: 0.82rem;
  float: left;
  margin-top: 0.35rem;
}
.mine-topbox .min-toptxbox .cu-item .cu-avatar.lg img {
  width: 3.2rem;
  height: 3.2rem;
  border: 2px solid #fdd190;
  border-radius: 50%;
}

.mine-topbox .min-toptxbox .cu-item .content .text-grey {
  color: #fefefe;
  text-shadow: 0px 2px 4px #e7b35e;
}

.cu-list.menu-avatar > .cu-item .content .text-grey-name {
  font-size: 0.853rem;
  color: #fff;
}
.cu-list.menu-avatar > .cu-item .content .text-grey-work {
  font-size: 0.7rem;
  color: rgba(254, 254, 254, 0.9);
}
.cu-list.menu-avatar > .cu-item .content .text-cut {
  font-size: 0.7rem;
  color: rgba(254, 254, 254, 0.9);
}

.cu-list.menu-avatar > .cu-item .content {
  float: left;
  line-height: 1.2rem;
  padding-top: 0.27rem;
  padding-left: 0.8rem;
}
.cardcode {
  float: left;
  padding-top: 0.9rem;
  padding-left: 0.8rem;
  text-align: center;
}
.cardcode .cardcode-img {
  width: 1.3rem;
}

.cardcode .text-grey-work {
  font-size: 0.7rem;
  color: rgba(254, 254, 254, 0.9);
}

.mine-topbox .topiconbox {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  padding-top: 1.25rem;
  width: 90%;
  margin: 0 auto;
}
.mine-topbox .topiconbox .toppicicon {
  flex: 0 0 25%;
}
.mine-topbox .topiconbox .toppicicon img {
  width: 1.44rem;
  height: 1.44rem;
  margin: 0 auto !important;
  display: block;
}
.mine-topbox .topiconbox .toppicicon p {
  text-align: center;
  display: block;
  color: #af7018;
  font-size: 0.64rem;
  padding-top: 0.64rem;
}

.mine-list {
  padding-top: 0.35rem;
}
.mine-list .mine-list-child {
  background: #fff;
  height: 2.07rem;
  padding-top: 0.6rem;

  border-bottom: 1px solid #efefef;
  overflow: hidden;
}
.mine-list .mine-list-child .mine-iconright {
  float: right;
  padding-top: 0.1rem;
  color: #cccccc;
  padding-right: 0.9rem;
}
.mine-list .mine-list-child .mine-iconright img {
  width: 0.4rem;
}
.mine-list .mine-list-child .mine-iconleft {
  float: left;
  padding-left: 0.86rem;
  padding-top: 0.23rem;
}
.mine-list .mine-list-child .mine-iconleft img {
  float: left;
  width: 0.96rem;
  padding-top: 0.05rem;
}

.mine-list .mine-list-child .mine-iconleft p {
  float: left;
  padding-left: 0.8rem;
  font-size: 0.746666rem;
  color: #333;
}
.mine-list .mine-list-child .mine-iconleft .mine-iconleft-badge {
  float: left;
  display: inline-block;
  width: 1rem;
  height: 1rem;
  line-height: 1rem;
  text-align: center;
  border-radius: 50%;
  background: red;
  font-size: 0.6rem;
  color: #fff;
  margin-left: 0.4rem;
}
.copyright {
  /*  position: absolute; */
  width: 100%;
  text-align: center;
  /*   bottom: 0.5rem; */
  color: #c4baa4;
  font-size: 0.72rem;
  line-height: 2.47rem;
}
.loginout {
  width: 100%;
  height: 2.47rem;
  line-height: 2.47rem;
  text-align: center;
  color: #f5495a;
  font-size: 0.72rem;
  background: #fff;
  margin-top: 0.35rem;
}
.bucunzaistyle {
  color: #fff;
}
.text-right {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-top: 1px solid #fff;
  border-right: 1px solid #fff;
  transform: rotate(45deg);
}
.text-grey-company {
  width: 11rem;
}
.mine-topbox .topinfobox {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  width: 84.8%;
  margin: 1.6rem auto 0;
  background: #fff;
  padding: 0.9rem;
  border-radius: 12px;
}
.mine-topbox .topinfobox .topinfoitem {
  flex: 0 0 25%;
}

.mine-topbox .topinfobox .topinfoitem p {
  text-align: center;
  display: block;
  color: #666;
  font-size: 0.7rem;
}
.mine-topbox .topinfobox .topinfoitem .p-num {
  color: #333;
  font-size: 0.853rem;
  padding-bottom: 0.15rem;
  font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/mine.vue